import { render } from "./detail-transaction-all.vue?vue&type=template&id=84199022"
import script from "./detail-transaction-all.vue?vue&type=script&lang=js"
export * from "./detail-transaction-all.vue?vue&type=script&lang=js"

import exportComponent from "/home/Work/max/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__